export default () => {
  const loader = document.querySelector('.loader-container');
  loader.classList.remove('loader-container_active-first-load');
};
